package com.fireavert.properties.fire_claim_data.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class FireClaimDataSaveResponse(val success: Boolean? = null)